import { render, staticRenderFns } from "./ThemeSwitchVertical.vue?vue&type=template&id=670f6541&scoped=true"
import script from "./ThemeSwitchVertical.vue?vue&type=script&lang=js"
export * from "./ThemeSwitchVertical.vue?vue&type=script&lang=js"
import style0 from "./ThemeSwitchVertical.vue?vue&type=style&index=0&id=670f6541&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670f6541",
  null
  
)

export default component.exports